<template>
  <component :is="overviewComponent" />
</template>

<script lang="ts" setup>
import { ResearchTopicTemplate } from "~/types/app";

const researchTopicTemplate = useResearchTopicTemplate();

const overviewComponent = computed(() => {
  switch (researchTopicTemplate) {
    case ResearchTopicTemplate.V2:
      return defineAsyncComponent(
        () => import("~/components/templates/v2/ResearchTopicOverview.vue")
      );
    case ResearchTopicTemplate.V1:
    default:
      return defineAsyncComponent(
        () => import("~/components/templates/v1/ResearchTopicOverview.vue")
      );
  }
});
</script>
